import * as React from 'react';
import { get, toLower } from 'lodash';

import ExportButton from '@inqool/uas-web-core/es/components/controls/ExportButton';
import { ColumnType } from '@inqool/uas-web-core/es/components/controls/Grid/constants';

import { typeEnum } from '@modules/protocols/_protocolsEnums';
import { formatToDecimals } from '@utils/utils';

export default [
  {
    label: 'Export',
    type: ColumnType.JSX,
    clickable: false,
    jsx: ({ row }) => (
      <div style={{ minWidth: 150, textAlign: 'center' }}>
        <ExportButton
          location={`${toLower(get(row, 'type', 'issue'))}ProtocolDetail`}
          urlPrefix="/metropolis"
          exportLabel="Export"
          input={{ params: {}, protocolId: get(row, 'id') }}
        />
      </div>
    ),
    width: 150
  },
  {
    label: 'Evidenční číslo',
    field: 'number',
    type: ColumnType.TEXT,
    width: 150
  },
  {
    label: 'Typ',
    field: 'type.id',
    displayField: 'type',
    type: ColumnType.ENUM,
    enum: typeEnum,
    width: 150
  },
  {
    label: 'Celková vypočtená suma',
    field: 'totalPrice',
    type: ColumnType.NUMBER,
    width: 150,
    mapper: v => formatToDecimals(v)
  },
  {
    label: 'Zaměstnanec, který zboží vrátil/bylo mu vydáno',
    field: 'employee.name',
    displayField: 'employee',
    mapper: parent => get(parent, 'fullName'),
    type: ColumnType.TEXT,
    width: 200
  },
  {
    label: 'Dodavatel zboží pokud jde o Dodejku',
    field: 'supplierName',
    displayField: 'supplier',
    mapper: parent => get(parent, 'name'),
    type: ColumnType.TEXT,
    width: 200
  },
  {
    label: 'Poznámka',
    field: 'note',
    type: ColumnType.TEXT,
    width: 200
  },
  {
    label: 'Sklad',
    field: 'warehouse.name',
    displayField: 'warehouse',
    mapper: parent => get(parent, 'name'),
    type: ColumnType.TEXT,
    width: 150
  },
  {
    label: 'Cílový sklad, pokud jde o Transfér',
    field: 'destinationWarehouse.name',
    displayField: 'destinationWarehouse',
    mapper: parent => get(parent, 'name'),
    type: ColumnType.TEXT,
    width: 150
  },
  {
    label: 'Typ likvidace, pokud jde o Likvidační protokol',
    field: 'disposalType.name',
    displayField: 'disposalType',
    mapper: parent => get(parent, 'name'),
    type: ColumnType.TEXT,
    width: 150
  },
  {
    label: 'Datum - vytvořeno',
    field: 'created',
    type: ColumnType.DATETIME,
    width: 150,
    compact: true
  }
];

export const protocolsRowColumns = [
  {
    label: 'Skladová karta',
    field: 'card.description',
    displayField: 'card',
    mapper: parent => get(parent, 'label'),
    type: ColumnType.TEXT,
    width: 200
  },
  {
    label: 'Množství',
    field: 'amount',
    type: ColumnType.NUMBER,
    width: 200
  },
  {
    label: 'Jednotková cena',
    field: 'unitPrice',
    type: ColumnType.NUMBER,
    width: 200,
    mapper: v => formatToDecimals(v)
  },
  {
    label: 'Výstrojní lhůta',
    field: 'daysLimit',
    type: ColumnType.NUMBER,
    width: 200
  },
  {
    label: 'Celková cena',
    field: 'totalPrice',
    type: ColumnType.NUMBER,
    width: 200,
    mapper: v => formatToDecimals(v)
  }
];



// WEBPACK FOOTER //
// ./src/modules/protocols/_protocolsColumns.tsx